import { IMenu } from "../models";


export class ModuleNavigatedMessage {
    public header: any;
    public menu: any;

    //TODO:DIW:Remove moduleName
    public moduleName: string;
  
    //TODO:DIW:Remove moduleName
    constructor(header?: any, menu?: any, moduleName?: string) {
      this.header = header;
      this.menu = menu;

      //TODO:DIW:Remove moduleName
      this.moduleName = moduleName;
    }
  }
  